import React, {
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState,
} from "react";
import { useInteractiveProductsSettings } from "./interactive-product-context.jsx";

const FollowProductsContext = createContext(null);
const FollowProductsDispatchContext = createContext(null);

export const useFollowProductsContext = () => {
	const context = useContext(FollowProductsContext);

	if (context === null) {
		console.error("[Interactive-Products] FollowProductsContext is not provided");
		return null;
	}

	return context;
};

export const useFollowProductsDispatchContext = () => {
	const context = useContext(FollowProductsDispatchContext);

	if (context === null) {
		console.error("[Interactive-Products] FollowProductsDispatchContext is not provided");
		return null;
	}

	return context;
};

const useFollowProducts = ({ allProducts }) => {


	const { disableFollowButton } = useInteractiveProductsSettings();

	const [followProducts, setFollowProducts] = useState(() => {

		if(disableFollowButton)
		{
			return {};
		}

		return allProducts.reduce((productFollowInfoByUID, currentValue) => {
			productFollowInfoByUID[currentValue.uid] = {
				isPending: false,
				following: currentValue.following,
			};

			return productFollowInfoByUID;
		}, {});
	});

	const addProductPendingRequest = useCallback((productUid) => {
		setFollowProducts((prevState) => {
			const existingProduct = prevState[productUid];

			return {
				...prevState,
				[productUid]: {
					...existingProduct,
					isPending: true,
				},
			};
		});
	}, []);

	const finishProductPendingRequest = useCallback((productUid, following = undefined) => {
		setFollowProducts((prevState) => {
			const followingMerge = following !== undefined ? {
				following,
			} : undefined;

			return {
				...prevState,
				[productUid]: {
					...prevState[productUid],
					isPending: false,
					...followingMerge,
				},
			};
		});
	}, []);

	return {
		followProducts,
		addProductPendingRequest,
		finishProductPendingRequest,
	};
};

export const FollowProductsContextProvider = ({ allProducts, children }) => {
	const {
		addProductPendingRequest,
		finishProductPendingRequest,
		followProducts,
	} = useFollowProducts({ allProducts });

	const dispatchContext = useMemo(
		() => ({ addProductPendingRequest, finishProductPendingRequest }),
		[addProductPendingRequest, finishProductPendingRequest]
	);

	return (
		<FollowProductsDispatchContext.Provider value={dispatchContext}>
			<FollowProductsContext.Provider value={followProducts}>
				{children}
			</FollowProductsContext.Provider>
		</FollowProductsDispatchContext.Provider>
	);
};
